<template>
  <div>
    <b-row>
      <b-col cols="12" class="person">
        <img src="@/assets/alert.svg" alt style="fill:rgb(75, 201, 219);" />
        <div class="user">
          <div class="name">{{name}}</div>
          <div class="role">Теоретический материал</div>
        </div>
      </b-col>
      <b-col sm="10">
        <div class="story " v-html="story"></div>
      </b-col>
      <b-col sm="10">
        <b-button
          @click="next"
          v-if="button && !proccess"
          variant="primary"
          style="margin-bottom: 30px; margin-top:20px; color:white; margin-left:80px; padding:10px 30px;"
        >Далее</b-button>
        <b-button
          @click="next"
          v-if="button && proccess"
          variant="primary"
          style="margin-bottom: 30px; margin-top:20px; color:white; margin-left:80px; padding:10px 30px;"
          :disabled="true"
        ><b-spinner small  ></b-spinner> Далее</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import API from "@/api";
export default {
  props: {
    story: String,
    name: String,
    button: Boolean, 
    page: Number, 
    data: Object
  },
  data() {
    return {
      proccess:false
    };
  },
  watch: {
    data: function (val) {
      this.proccess = false
    },
  },
  methods: {
    next() {
      this.proccess = true
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      };
      const data = new FormData();
      data.append("page", this.page);
      API.post("api/page_next/", data, config).then(response => {
        this.$emit("answered");
      });
    }
  }
};
</script>
<style >
.story {
  margin-left: 80px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.5;
  margin-top: 5px;
  color: black;
}

.next {
  margin-left: 80px;
  font-size: 24px;
  font-weight: bold;
}
.person img {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  margin-right: 10px;
  float: left;
}
.user {
  margin-top: 20px;
  align-content: center;
}
.name {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 5px;
  line-height: 20px;
  color: #2e2e2e;
}
.role {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.8);
}

</style>